import React from 'react';
import { Flex } from 'antd';
import i18next from 'i18next';

export const inviteColumns = (getStatusIcon) => {
  return [
    {
      title: i18next.t('Nome'),
      dataIndex: 'employee_name',
      key: 'employee_name',
    },
    {
      title: i18next.t('Telefone'),
      dataIndex: 'employee_phone',
      key: 'employee_phone',
    },
    {
      title: i18next.t('Setor'),
      dataIndex: 'sector_name',
      key: 'sector_name',
    },
    {
      title: i18next.t('Operacional'),
      dataIndex: 'operational_name',
      key: 'operational_name',
    },
    {
      title: i18next.t('Status'),
      key: 'status',
      render: (_, record) => (
        <Flex align="center" justify="center">
          {getStatusIcon(record.status)}
        </Flex>
      ),
    },
  ];
};
